"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRoyaltyTier = exports.deleteRoyaltyTier = exports.addRoyaltyTier = void 0;
const anchor_1 = require("@project-serum/anchor");
const state_1 = require("../state");
/**
 * Add a new royalty tier
 * This associates a quantity of staked tokens with a marketplace
 * royalty fee discount if it does not already exist
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - the authority of the market
 * @param registeredCurrency - a valid registered currency
 * @param stakeAmount - the staked amount in the token's base units
 * @param discount - the discount amount (Discount of '1_000_000' == 100%)
 * @returns InstructionReturn
 */
function addRoyaltyTier(program, updateAuthorityAccount, registeredCurrency, stakeAmount, discount) {
    const registeredCurrencyAddress = 'key' in registeredCurrency
        ? registeredCurrency.key
        : registeredCurrency.registeredCurrency.key;
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .addRoyaltyTier(new anchor_1.BN(stakeAmount), new anchor_1.BN(discount))
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: registeredCurrencyAddress,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.addRoyaltyTier = addRoyaltyTier;
/**
 * Delete an existing royalty tier
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - the authority of the market
 * @param registeredCurrency - a valid registered currency
 * @param stakeAmount - the staked amount in the token's base units
 * @returns InstructionReturn
 */
function deleteRoyaltyTier(program, updateAuthorityAccount, registeredCurrency, stakeAmount) {
    const registeredCurrencyAddress = 'key' in registeredCurrency
        ? registeredCurrency.key
        : registeredCurrency.registeredCurrency.key;
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .deleteRoyaltyTier(new anchor_1.BN(stakeAmount))
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: registeredCurrencyAddress,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.deleteRoyaltyTier = deleteRoyaltyTier;
/**
 * Update the discount rate associated with a given royalty tier if it exists
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - the authority of the market
 * @param registeredCurrency - a valid registered currency
 * @param stakeAmount - the staked amount in the token's base units
 * @param discount - the new discount amount (Discount of '1_000_000' == 100%)
 * @returns InstructionReturn
 */
function updateRoyaltyTier(program, updateAuthorityAccount, registeredCurrency, stakeAmount, discount) {
    const registeredCurrencyAddress = 'key' in registeredCurrency
        ? registeredCurrency.key
        : registeredCurrency.registeredCurrency.key;
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .updateRoyaltyTier(new anchor_1.BN(stakeAmount), new anchor_1.BN(discount))
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: registeredCurrencyAddress,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.updateRoyaltyTier = updateRoyaltyTier;
//# sourceMappingURL=royaltyTiers.js.map